const bannerSize = 3145728;

export default bannerSize;
